import { list } from 'redom';

import EventRegistration from './registration';

class EventRegistrartionsList {

  constructor() {

    this.registrations = [];

    this.el = list('ul.event-guests-list', EventRegistration);

  }

  update(registrations, eventOwnerId) {

    this.el.update(registrations, eventOwnerId);

  }

}

export default EventRegistrartionsList;